import type { ReactElement } from "react";

import { StyledIcon } from "./styles";

export const FilterItemUpgradeIcon = (): ReactElement => {
    return (
        <StyledIcon
            size="xs"
            iconName="sparkles"
        />
    );
};
